import styled from 'styled-components';
import { colors, MediaQuery } from '../../../theme/style-helpers';
import ChevronRightBlack from '../../../assets/icons/ChevronRightBlack.svg';
import ChevronRightOrange from '../../../assets/icons/ChevronRightOrange.svg';
import ChevronLeftBlack from '../../../assets/icons/ChevronLeftBlack.svg';
import ChevronLeftOrange from '../../../assets/icons/ChevronLeftOrange.svg';

export const FiltersAndTableContainer = styled.div`
  display: grid;
  grid-gap: 32px;
`;

export const PaginationContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: center;
  grid-gap: 32px;
  margin-bottom: 40px;

  button:first-child, button:last-child {
    ${MediaQuery.xSmall`
      display: none;
    `}
  }
`;

export const PageNumber = styled.button`
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
  border: none;
  background-color: transparent;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  ${({ selected }) => selected && `
    font-weight: 700;
    border-bottom: 2px solid ${colors.BRAND_ORANGE};
  `};
`;

export const NoResults = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: center;
  margin-bottom: 85px;
`;

export const TableContainer = styled.div`
  width: 100%;
  margin-top: -42px;
  overflow-x: auto;
  transform: rotateX(180deg);
  -ms-transform: rotateX(180deg); /* IE 9 */
  -webkit-transform: rotateX(180deg); /* Safari and Chrome */

  >table, ${PaginationContainer}, ${NoResults} {
    transform: rotateX(-180deg);
    -ms-transform: rotateX(-180deg); /* IE 9 */
    -webkit-transform: rotateX(-180deg); /* Safari and Chrome */

    .sticky {
      position: -webkit-sticky;
      position: sticky;

      &.column-0 {
        left: 0;
        width: 85px;
        z-index: 2;
      }

      &.column-1 {
        left: 85px;
        z-index: 1;
      }
    }
  }

  &::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px 1px ${colors.COOL_GREY};
    border-radius: 100px;
    border: 1px solid transparent;

    ${MediaQuery.medium`
      margin-left: 12px;
      margin-right: 12px;
    `}
  }

  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 8px 8px ${colors.BRAND_ORANGE};
    border: 2px solid transparent;
    border-radius: 100px;
  }

  &::-webkit-scrollbar-button:horizontal:decrement {
    background-image: url(${ChevronLeftOrange});
    background-size: 14px 14px;
    background-position: center center;
    background-repeat: no-repeat;

    &:hover {
      background-image: url(${ChevronLeftBlack});
    }
  }

  &::-webkit-scrollbar-button:horizontal:increment {
    background-image: url(${ChevronRightOrange});
    background-size: 14px 14px;
    background-position: center center;
    background-repeat: no-repeat;

    &:hover {
      background-image: url(${ChevronRightBlack});
    }
  }
`;

export const StyledTable = styled.table`
  margin-bottom: 16px;
  min-width: 100%;

  thead {
    background-color: ${colors.LIGHT_GREY};
    border-radius: 1px;

    tr {

      th {
        background-color: ${colors.GREY_LIGHT};
        font-weight: 500;
      }

      &:hover {
        th {
          background-color: ${colors.GREY_LIGHT};
        }
      }
    }
  }

  td, th {
    padding: 16px 16px;
    white-space: nowrap;
  }

  tbody tr {
    border-bottom: 1px solid ${colors.COOL_GREY};

    td {
      background-color: ${colors.WHITE};
    }

    &:hover {
      cursor: pointer;
      
      td {
        background-color: ${colors.GREY_LIGHT};
      }
    }
  }

  th {
    font-size: 14px;
    font-weight: 600;
    line-height: 19px;
    letter-spacing: 0em;
    cursor: pointer;

    &:first-child {
      width: 90px;
    }

    img {
      margin-left: 8px;
    }
  }

  .single-row {
    height: 300px;
  }
`;

export const TableDataCell = styled.td`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  vertical-align: ${({ topAligned }) => (topAligned ? 'top' : 'baseline')};
  text-align: ${({ textAlignCenter }) => (textAlignCenter ? 'center' : 'left')};

  span {
    font-weight: 600;
    line-height: 19px;
  }
`;

export const ReversedIcon = styled.img`
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
`;

export const CellContainer = styled.div`
  display: grid;
  grid-gap: 4px;
`;

export const StatusContainer = styled.div`
  display: grid;
  grid-gap: 8px;
`;

export const StatusLine = styled.div`
  position: relative;
  width: 120px;
  height: 1px;
  border-radius: 100px;
  background-color: ${colors.COOL_GREY};

  &:before {
    content: '';
    position: absolute;
    width: ${({ bgWidth }) => ((bgWidth && bgWidth > 0) ? (120 * bgWidth) / 100 : 0)}px;
    height: 1px;
    background-color: ${({ bgColor }) => bgColor && bgColor};
  }
`;
